<template>
  <span>
    <v-menu
    v-if="!mobileMode"
      v-model="menuOpen"
      :close-on-content-click="false"
      left
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom color="primary">
          <template #activator="{ on: tooltip }">
            <v-row align="center" class="mt-4 mr-n2" no-gutters>
              <v-icon color="primary" v-bind="attrs" v-on="{...tooltip, ...menu}">mdi-application-edit</v-icon>
            </v-row>
          </template>
          <span class="subtitle-1 white--text" style="white-space: pre-line">
            {{$t('adjustWidgets')}}
          </span>
        </v-tooltip>
      </template>
      <TicketsWidgetPickerCard
        v-if="menuOpen"
        :propChartSet="chartSet"
        :openMenuKey="openMenuKey"
        @new-chart-layout="apply"
        @changed="changeEmitted">
      </TicketsWidgetPickerCard>
    </v-menu>

    <Icon :small="false" icon="mdi-application-edit" margin="mt-4 mr-n2" @icon-clicked="pickerIconClicked" v-else>
    </Icon>

    <Dialog :stateId="dialogId">
      <TicketsWidgetPickerCard
        v-if="mobileMode && dialogOpen"
        :mobileMode="true"
        @close="closeDialog"
        :propChartSet="chartSet"
        :openMenuKey="openMenuKey"
        @new-chart-layout="apply"
        @changed="changeEmitted"
      />
    </Dialog>
  </span>
</template>

<script>
import { BaseDashboardWidgetSet } from '@/model/DashboardWidget.js'
import { uniqueDialogId } from '@/utils/componentHelpers.js'
import { mapActions } from 'vuex'

export default {
  name: 'TicketsWidgetPicker',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    TicketsWidgetPickerCard: () => import('@/components/dashboard/TicketsWidgetPickerCard.vue')
  },

  props: {
    propChartSet: BaseDashboardWidgetSet,
    openMenuKey: { type: Number, required: false, default: 0 }
  },

  data: () => ({
    chartSet: null,
    menuOpen: false,
    dialogOpen: false,
    changed: false,
    tabsChecked: { general: false, mill: false, supplier: false },
    isReorderMode: false,
    dialogId: uniqueDialogId('tickets-widget-picker-dialog')
  }),

  watch: {
    menuOpen (val) {
      if (val === true) {
        this.changed = false
      } else {
        this.chartSet = this.propChartSet.clone()
      }
    },

    dialogOpen (val) {
      if (val === true) {
        this.changed = false
      } else {
        this.chartSet = this.propChartSet.clone()
      }
    },

    openMenuKey () {
      if (!this.menuOpen) this.menuOpen = true
    }
  },

  created () {
    this.chartSet = this.propChartSet.clone()
  },

  computed: {
    mobileMode () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },

  methods: {
    ...mapActions('dialog', ['openOrUpdateDialog', 'closeDialogsAtOrAbove']),
    apply (i) {
      this.closeDialog()
      this.menuOpen = false
      this.$emit('new-chart-layout', i)
    },

    openDialog () {
      this.openOrUpdateDialog(this.dialogId)
      this.dialogOpen = true
    },

    closeDialog () {
      this.closeDialogsAtOrAbove(this.dialogId)
      this.dialogOpen = false
    },

    pickerIconClicked () {
      if (this.mobileMode) {
        this.openDialog()
      }
    },

    changeEmitted (val) {
      this.changed = val
    }
  }
}
</script>
